<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>

      <div *ngFor="let element of def_menu">

        <li *ngIf="element.type == 'elm'">

          <a *ngIf="!isCondensed" [routerLink]="element.link" routerLinkActive="active" class="side-nav-link-ref">
            <i [ngClass]="element.class"></i>
            <span>{{element.span | translate}}</span>
          </a>
          <a *ngIf="isCondensed" [routerLink]="element.link" routerLinkActive="active" class="side-nav-link-ref">
            <i [ngClass]="element.class"></i>
            <span></span>
          </a>

        </li>
        <li *ngIf="element.type == 'head' && !isCondensed" [ngClass]="element.class">{{element.span}}</li>
      </div>

    </ul>
  </div>
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <perfect-scrollbar [config]="configData">
    <div *ngIf="!isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <div *ngIf="isCondensed">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </perfect-scrollbar>
</div>
<!-- Left Sidebar End -->